'use client';
import React, { useContext, useEffect, useState } from 'react';
import { formatPercentage, formatPriceWithCurrency } from '@benzinga/utils';
import { getClassnameByValue, sanitizeHTML } from '@benzinga/frontend-utils';
import { Button } from '@benzinga/core-ui';
import styled from '@benzinga/themetron';
import { BzImage } from '@benzinga/image';
import { SessionContext } from '@benzinga/session-context';
import { CryptoManager, CoinData } from '@benzinga/crypto-manager';

type Variant = 'default' | 'compact';

export interface MoonOrBustProps {
  coinDisclosure?: string;
  symbol?: string;
  coingecko_id?: string;
  partnerLink?: string;
  variant?: Variant;
  cryptoData?: {
    coin_data?: CoinData;
    partnerLink?: string;
    num_votes?: number;
  };
}

export const MoonOrBust: React.FC<MoonOrBustProps> = ({
  coinDisclosure,
  coingecko_id,
  cryptoData = {},
  partnerLink,
  symbol,
  variant = 'default',
}) => {
  const [numberOfVotes, setNumberOfVotes] = useState<number>(cryptoData?.num_votes ?? 0);
  // const [numberOfMoonVotes, setNumberOfMoonVotes] = useState<number | null>(null);
  // const [numberOfBustVotes, setNumberOfBustVotes] = useState<number | null>(null);
  // const [popupVisible, setPopupVisible] = useState(false);
  const [coin, setCoin] = useState<CoinData | null>(cryptoData?.coin_data ?? null);
  // const [position, setPosition] = useState<string>('');
  const [url, setURL] = useState<string | undefined>(cryptoData?.partnerLink ?? '');
  const session = useContext(SessionContext);
  const cryptoManager = session.getManager(CryptoManager);

  useEffect(() => {
    if (!cryptoData?.coin_data) {
      const coinSymbol = coingecko_id ?? symbol;
      if (coinSymbol) {
        cryptoManager.getCoin(coinSymbol).then(res => {
          if (res?.ok) {
            setCoin(res.ok);
            if (partnerLink === '') {
              fetchHowToBuyArticle(res.ok.symbol);
            }
            // fetchGetNumberOfVotes(res.ok.coingecko_id);
          }
        });
      }

      const fetchHowToBuyArticle = (symbol: string) => {
        if (!symbol) return;
        cryptoManager.getHowToBuyArticle(symbol).then(res => {
          if (res?.ok?.status === 'missing_how_to_buy') return;
          if (res?.ok) {
            if (res.ok && res.ok[0] && res.ok[0]?.canonical && res.ok[0].canonical == window.location.href) {
              setURL(partnerLink);
            } else {
              setURL(res.ok && res.ok[0] ? res.ok[0].url : partnerLink);
            }
          }
        });
      };

      // const fetchGetNumberOfVotes = (coinId: string) => {
      //   if (!coinId) return;
      //   cryptoManager.getNumberOfVotes(coinId).then(res => {
      //     if (res?.ok?.num_votes) {
      //       setNumberOfVotes(res.ok.num_votes);
      //     }
      //   });
      // };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const handleClosePopup = () => setPopupVisible(false);

  // const submitVote = (email: string, newPosition: string) => {
  //   if (!coin?.coingecko_id || !email || !newPosition) return;

  //   const voteParams = {
  //     coin: coin?.coingecko_id,
  //     email,
  //     vote: newPosition,
  //   };

  //   cryptoManager.postMOBVote(voteParams).then(res => {
  //     if (res?.ok?.num_votes) {
  //       setNumberOfVotes(res.ok.num_votes);
  //       setNumberOfBustVotes(res.ok.results.BUST ?? 0);
  //       setNumberOfMoonVotes(res.ok.results.MOON ?? 0);
  //       handleClosePopup();
  //     }
  //   });
  // };

  // const handleChooseOption = (newPosition: string) => {
  //   const emailInLocalStorage = localStorage.getItem('mob-email') || localStorage.getItem('email');
  //   if (emailInLocalStorage) {
  //     submitVote(emailInLocalStorage, newPosition);
  //   } else {
  //     setPopupVisible(true);
  //     setPosition(newPosition);
  //   }
  // };

  // const onEmailCapture = (email: string) => {
  //   localStorage.setItem('email', email);
  //   submitVote(email, position);
  //   handleClosePopup();
  // };

  if (!coin) return null;

  return (
    <Container className={`moon-or-bust-card ${variant}`}>
      {/* <EmailCapture
        actionText="Submit"
        description="Our team is diligently working to keep up with trends in the crypto markets. Keep up to date on the latest news and up-and-coming coins."
        handleClosePopup={handleClosePopup}
        hubspotFormId="5f16b7e9-2a75-474f-84ae-bd83a47223c5"
        isOpen={popupVisible}
        onEmailCapture={onEmailCapture}
        title="JOIN THE MOON OR BUST EMAIL LIST"
      /> */}
      <div className="coin-image-container">
        {coin.image && (
          <div className="coin-image-wrapper">
            <BzImage alt={`${coin.name} thumbnail`} layout="fill" src={coin.image} />
          </div>
        )}
        <div className="name-symbol-container">
          {coin.symbol && <h4 className="coin-symbol">{coin.symbol}</h4>}
          {coin.name && <span className="coin-name">{coin.name}</span>}
        </div>
      </div>
      {coin.current_price && (
        <div className="price-container">
          <h4 className="coin-price">{formatPriceWithCurrency(coin.current_price, 'USD', { showNearZero: true })}*</h4>
          <span className="price-info">
            <sup>*</sup>prices delayed up to 10 minutes
          </span>
        </div>
      )}
      {coin.price_change_percentage_24h && (
        <div className="price-change-container">
          <h4 className={`coin-price-change-percentage ${getClassnameByValue(coin.price_change_percentage_24h)}`}>
            {coin.price_change_percentage_24h > 0
              ? `+${formatPercentage(coin.price_change_percentage_24h)}%`
              : `${formatPercentage(coin.price_change_percentage_24h)}%`}
          </h4>
          <span className="coin-price-change-timeframe">24H</span>
        </div>
      )}
      <Button
        as="a"
        className="how-to-buy-button"
        href={url}
        rel="noopener noreferrer"
        target="_blank"
        variant="flat-orange"
      >
        {partnerLink ? `Buy ${coin.name}` : `How To BUY`}
      </Button>

      {/* <div className="moon-bust-buttons">
        <Button onClick={() => handleChooseOption('MOON')} variant="flat-blue">
          MOON
        </Button>
        <Button onClick={() => handleChooseOption('BUST')} variant="flat-red">
          BUST
        </Button>
      </div> */}

      {/* <div className="number-of-votes-container">
        <div>{numberOfVotes} votes</div>
        {(numberOfBustVotes || numberOfMoonVotes) && (
          <div className="moon-bust-votes">
            <span>MOON: {numberOfMoonVotes}</span>
            <span>BUST: {numberOfBustVotes}</span>
          </div>
        )}
      </div> */}
      {coinDisclosure && (
        <p className="bz-disclosure-content m-0 text-xs font-manrope text-blue-light_40 font-medium leading-snug block mt-2">
          <strong>Disclosure: </strong>
          <span dangerouslySetInnerHTML={{ __html: sanitizeHTML(coinDisclosure) }}></span>
        </p>
      )}
    </Container>
  );
};

const Container = styled.div`
  &.moon-or-bust-card {
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${({ theme }) => theme.borderRadius.sm};
    display: flex;
    flex-direction: column;
    line-height: 1.2;
    padding: 1rem;
    box-shadow: ${({ theme }) => theme.shadow.sm};

    &:hover {
      box-shadow: ${({ theme }) => theme.shadow.md};
    }

    .coin-image-wrapper {
      height: 90px;
      position: relative;
    }

    .coin-symbol,
    .coin-price,
    .coin-price-change-percentage {
      font-size: ${({ theme }) => theme.fontSize['2xl']};
      color: ${({ theme }) => theme.colorPalette.gray700};
      font-weight: ${({ theme }) => theme.fontWeight.bold};
    }

    .coin-name,
    .price-info,
    .coin-price-change-timeframe {
      color: ${({ theme }) => theme.colorPalette.gray400};
    }

    .price-info {
      font-size: ${({ theme }) => theme.fontSize.sm};
    }

    .coin-price-change-percentage {
      &.green {
        color: ${({ theme }) => theme.colorPalette.green500};
      }

      &.red {
        color: ${({ theme }) => theme.colorPalette.red500};
      }
    }

    .name-symbol-container {
      .coin-symbol {
        text-transform: uppercase;
      }
    }

    .how-to-buy-button {
      cursor: pointer;
      width: 100%;
    }

    &.default {
      text-align: center;
      align-items: center;
      max-width: 400px;
      width: 100%;

      .coin-image-wrapper {
        height: 70px;
        position: relative;
      }
      .coin-name {
        font-size: ${({ theme }) => theme.fontSize['3xl']};
        color: ${({ theme }) => theme.colorPalette.gray700};
      }
      .coin-symbol {
        display: none;
      }
      .coin-price {
        font-size: ${({ theme }) => theme.fontSize['3xl']};
      }
      .coin-price-change-percentage {
        margin: 0.3rem 0;
      }
      .coin-price-change-timeframe {
        font-size: ${({ theme }) => theme.fontSize.base};
      }
      .how-to-buy-button {
        margin-top: 0.5rem;
        height: 40px;
      }
      .moon-bust-buttons {
        display: flex;
        width: 100%;
        margin-top: 0.7rem;
        gap: 0.4rem;

        button {
          width: 100%;
          height: 40px;
          color: #ffffff;
        }
      }

      .number-of-votes-container {
        margin-top: 0.5rem;
        font-weight: ${({ theme }) => theme.fontWeight.bold};
        width: 100%;

        .moon-bust-votes {
          display: flex;
          justify-content: space-between;
          width: 100%;
          gap: 0 0.5rem;
          margin-top: 0.4rem;
        }
      }
    }

    &.compact {
      width: 100%;
      display: flex;
      gap: 1.5rem;
      flex-wrap: wrap;
      justify-content: center;
      flex-direction: unset;

      .coin-image-container {
        display: flex;
        .coin-image-wrapper {
          height: 50px;
          width: 50px;
          min-width: 50px;
          margin-right: 1rem;
        }
      }

      .name-symbol-container {
        .coin-name {
          font-size: ${({ theme }) => theme.fontSize.base};
        }
      }
      .price-container {
        text-align: center;
        .coin-price {
        }
      }

      .price-change-container {
        text-align: center;
      }
      .how-to-buy-button {
        height: 50px;
        max-width: 200px;
      }
      .moon-bust-buttons,
      .number-of-votes-container,
      .coin-disclosure {
        display: none;
      }
      @media screen and (min-width: 600px) {
        .price-container {
          margin-right: auto;
          text-align: left;
        }
        .price-change-container {
          margin-left: auto;
          text-align: right;
        }
      }
    }
  }
`;
